// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"a3-z","displaySixCardTiles":"b3-z"};